import React from 'react'
import { Text } from '@components/common'
import { DeprecProdUnit } from '@api/models'

interface ProductionUnitsDeleteFormProps {
  unit: DeprecProdUnit
}

const ProductionUnitsDeleteForm: React.FC<ProductionUnitsDeleteFormProps> = ({ unit }) => {
  return (
    <>
      <Text>
        Are you sure you want to delete production units record for{' '}
        <Text bold>Year: {unit.FiscalYear}</Text> -{' '}
        <Text bold>Period: {unit.FiscalPeriod}</Text> ? This action cannot be undone.
      </Text>
    </>
  )
}

export default ProductionUnitsDeleteForm
